import { getOrderCodeState } from "components/_ProductConfigurator/_helpers";
import { getAccessoriesData } from "utils";

export const wizardOrderCodeToProductApiAdapter = (
  orderCode,
  selectedAccessories,
) => {
  if (!orderCode?.state) {
    return null;
  }

  return {
    ordercodestate: {
      optionStates: orderCode?.state?.optionStates || [],
    },
    propertyStates: orderCode?.propertyStates || null,
    currentStrategyId: orderCode?.currentStrategyId || null,
    selectedAccessories: selectedAccessories
      ? selectedAccessories.map(({ _title, ...item }) => item)
      : [],
  };
};

export const productToWizardOrderCodeAdapter = (
  initOrderCode,
  product,
  requestParams,
) => {
  if (!product) {
    return null;
  }

  return {
    ...initOrderCode,
    presentation: product.orderCode.presentation,
    orderCode: {
      seriesId: requestParams.seriesId,
      state: {
        optionStates: getOrderCodeState(product.orderCode.parts),
      },
      propertyStates: product.orderCode.propertyStates,
      currentStrategyId: product.currentStrategyId,
    },
    propertyStates: requestParams?.state?.propertyStates,
    currentStrategyId: requestParams?.state?.currentStrategyId,
    selectedAccessories: getAccessoriesData(
      product.selectedAccessories,
      product.accessoryGroups,
    ),
  };
};
